export default __webpack_public_path__ + "static/media/330_store03-jp-mobile.bd59674f.png";